import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../services/login.service';
import { ChangePassword } from '../../shared/models/changePassword.interface';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})

export class ChangePasswordComponent extends AbstractBiditComponent implements OnInit {

  chgPwd: ChangePassword;
  showPwdChange = false;
  token: string

  constructor(deviceDetectorService: DeviceDetectorService,
    private loginService: LoginService, private router: Router, private route: ActivatedRoute) {
    super(deviceDetectorService);
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.token = params.get('token');
      if (this.token != null) {
        this.chgPwd = { resetCode: this.token, email: '', newPassword: '', confirmPassword: null }
        this.showPwdChange = true;
      }
    });

    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      if (this.token != null) {
        this.chgPwd = { resetCode: this.token, email: '', newPassword: '', confirmPassword: null }
        this.showPwdChange = true;
      }
    });
  }

  validatePassword(password: string): boolean {
    let valid = true;
    if (password.length < 8) valid = false;
    if (password.toUpperCase() == password) valid = false;
    if (password.toLowerCase() == password) valid = false;

    let charCheck = password.match(/[a-z]+/i);
    if (charCheck && charCheck.length == 1 && charCheck[0] == password) valid = false;

    if (!valid) this.errors = $localize`Password must be at least 8 characters long. Password must have at least: 1 upper case letter, 1 lower case letter, 1 number.`;
    return valid;
  }
 
  changePassword(form: NgForm) {
    this.errors = '';
    if (form.valid) {
      if (!this.validatePassword(this.chgPwd.newPassword)) {
        return;
      }

      this.isRequesting = true;
      this.loginService.changePassword(this.chgPwd)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next:(result) => {
            alert($localize`Your password is reset, you can now try logging into your BIDIT account`);
            this.router.navigate(['/login']);
          },
          error: (error: string) => this.errors = error});
    }
  }

}
